export interface ApiConfig {
  url: string;
  timeout: number;
  unit: 'main' | 'chat' | 'analyzer';
}

export const DEFAULT_API_CONFIG: ApiConfig = {
  url: `${process.env.REACT_APP_API_BASE_URL}`,
  timeout: 60000,
  unit: 'main',
};
